import { render, staticRenderFns } from "./AllotteesBacolodIloiloPanay2021Gathering.vue?vue&type=template&id=4e292f8a&scoped=true"
import script from "./AllotteesBacolodIloiloPanay2021Gathering.vue?vue&type=script&lang=js"
export * from "./AllotteesBacolodIloiloPanay2021Gathering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e292f8a",
  null
  
)

export default component.exports